import styled from 'styled-components';

export const Container = styled.main<{ scroll?: boolean; column?: boolean }>`
  flex: 1;
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  padding: ${({ theme }) => theme.metrics.padding} 10%;
  gap: ${({ theme }) => theme.metrics.gap};
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.metrics.desktop_xlarge}) {
    padding: ${({ theme }) => theme.metrics.padding};
  }

  @media (max-width: ${({ theme }) => theme.metrics.desktop_small}) {
    max-height: initial;
    flex-direction: column;
    align-items: center;
  }
`;
